<template>
    <div class="dfRegion clearfix" :class="colClass">
        <ChildrenList :children-ids="children" :view-only="isViewOnly"></ChildrenList>
        <ErrorList :data="data" />
        <AdminSettingsDifferences :data="data" />
    </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import MspPaymentReceiptDef from "../elements/MspPaymentReceiptDef";
import { AbstractPayReceiptSettings } from "@/cs-ts-bridge/ts/abstract-pay-receipt-settings";
import { props, Props, components, setup } from "./BaseDefMixin.3";
export default defineComponent({
    components: {
        ...components,
    },
    props: props,
    //@ts-ignore
    setup(props: Props<MspPaymentReceiptDef, AbstractPayReceiptSettings>) {
        const base = setup<MspPaymentReceiptDef, AbstractPayReceiptSettings>(props);

        return {
            ...base.expose,
        };
    },
});
</script>
